/*
 * Copyright (c) 2023-2024. Haodong JU
 */

import hillo from 'hillo'
import { getRealADI } from '@/model/dataLayer/api/storage/storage'
import { storageNewApiHost } from '@/model/dataLayer/api/storage/inventoryUtils'

const name = 'inventoryRecord/'

export async function getClearList () {
  return (await hillo.jsonPost(storageNewApiHost + name + 'getClearingsList', {}, await getRealADI())).data
}

export async function getClearingSummary (dateTimeFrom = null, dateTimeTo = null, operation = null) {
  return (await hillo.jsonPost(storageNewApiHost + 'resourceLog/' + 'getSummaries', {
    dateTimeFrom,
    dateTimeTo,
    operation
  }, await getRealADI())).data
}

export async function getResourceCount (clearingId) {
  return (await hillo.jsonPost(storageNewApiHost + name + 'getDishResourceAmount/' + clearingId, {}, await getRealADI())).data
}

export async function getStatistic (dateTimeFrom = null, dateTimeTo = null) {
  return (await hillo.jsonPost(storageNewApiHost + 'statistics/' + 'getDetail', {
    dateTimeFrom,
    dateTimeTo
  }, await getRealADI())).data
}

export async function getInOutLog (dateTimeFrom = null, dateTimeTo = null) {
  return (await hillo.jsonPost(storageNewApiHost + 'resourceLog/' + 'getDetailList', {
    dateTimeFrom,
    dateTimeTo
  }, await getRealADI())).data
}
